import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const EmailStyles = styled(OnboardingPage)`
  ion-content {
    .onboarding-email-title {
      margin: 0 0 8px;
      text-align: center;
    }

    .email-images {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px 0;
      height: 300px;
      margin-bottom: 0;

      .email-circle {
        position: absolute;
        width: 500px;
        height: 500px;
        z-index: -1;
      }

      .email-lady {
        position: absolute;
        width: 350px;
        height: 350px;
        z-index: -1;
      }
    }

    .images-container {
      margin: 16px 0;
      height: 268px;
      width: 100%;
      background-color: transparent;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }

      .images-view {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 472px;
        height: 100%;

        .images-view-line {
          &:not(:first-child) {
            margin-top: 4px;
          }

          &:nth-child(even) {
            transform: translateX(33px);
          }

          &:nth-child(2) {
            opacity: 0.9;
          }

          &:nth-child(3) {
            opacity: 0.6;
          }

          &:nth-child(4) {
            opacity: 0.3;
          }

          display: flex;
          gap: 4px;

          img {
            display: block;
            width: 64px;
            height: 64px;
            border-radius: 12px;
          }
        }
      }
    }

    .email-title {
      @media screen and (max-width: 360px) {
        margin-bottom: 10px;
      }
    }

    .email-disclaimer {
      text-align: center;
      margin: 12px 0 0;
    }

    .email-input-container {
      max-width: 372px;
      padding: 0 16px;
      width: 100%;
      margin: 16px auto 0;
    }

    .email-protection {
      margin: 16px auto;
      padding: 0 16px;
      max-width: 372px;
    }
  }
`;
